module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/poster-5-80cd0fb1cc716f061c905e27f026e5ac.jpg";